import { useSelector, useDispatch } from "react-redux";
import {
  Box,
  Typography,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import BookModelRight from "./BookModelRight";
import ArgumentField from "./ArgumentField";
import { useEffect, useState } from "react";
import {
  setSelectedLayout,
  setSelectedLayoutPlaylistItems,
} from "../../redux/slices/selectedLayoutSlice";
import { setTemplateValues } from "../../redux/slices/templateValuesSlice";

export const InputLayoutForm = ({ layoutItem, open, onClose }) => {
  const dispatch = useDispatch();
  const playlistId = layoutItem?.playlistId;
  const playlists = useSelector((state) => state?.playlist?.playlist);
  const templates = useSelector((state) => state?.template?.template); 
  const [editableValues, setEditableValues] = useState({});
  const selectedPlaylist = playlists?.find((p) => p.id === playlistId);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );

  useEffect(() => {
    if (open && selectedPlaylist) {
      const meetingObject =
        JSON.parse(localStorage.getItem("meetingObject")) || {}; 

      selectedPlaylist?.items?.forEach((item) => {
        if (item.type === "template") {
          const templateEntry = templates.find(
            (t) => t.id === item.content_ref
          );

          if (templateEntry) {
            const updatedArguments = {
              ...templateEntry.arguments,
              event_name:
                meetingObject?.name ||
                templateEntry?.arguments?.event_name ||
                "",
              host_name:
                meetingObject?.user ||
                templateEntry?.arguments?.host_name ||
                "",
            };

            dispatch(
              setTemplateValues({
                id: templateEntry.id,
                argumentsValues: updatedArguments,
                customProperties: {},
              })
            );
          }
        }
      });
    }
  }, [open, selectedPlaylist, templates, dispatch]);
  const selectedTemplateValues = useSelector((state) => state?.templateValues);

  const handleInputChange = (key, value, id, playlistItemId) => {
  
    const existingArguments = selectedTemplateValues[id]?.arguments || {};

    setEditableValues((prevValues) => {
      const updatedValues = {
        ...prevValues,
        [`${playlistItemId}_${key}`]: value,
      };

      dispatch(
        setTemplateValues({
          id,
          argumentsValues: {
            ...existingArguments,
            [key]: value,
          },
          customProperties: selectedTemplateValues[id]?.customProperties || {},
        })
      );

      return updatedValues;
    });
  };

  const handleFileChange = (key, file, id, playlistItemId) => {
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setEditableValues((prevValues) => {
          const updatedValues = {
            ...prevValues,
            [`${playlistItemId}_${key}`]: base64String,
          };

          dispatch(
            setTemplateValues({
              id,
              playlistItemId,
              argumentsValues: { [key]: base64String },
              customProperties: {},
            })
          );
          return updatedValues;
        });
      };
      reader.readAsDataURL(file);
    }
  };
  useEffect(() => {
    setSelectedLayout(layoutItem);
  }, [layoutItem]);

  const handleConfirm = () => {
    const selectedLayoutData = {
      layoutId: layoutItem,
      editableValues,
    };
    dispatch(setSelectedLayout(selectedLayoutData));
    dispatch(setSelectedLayoutPlaylistItems(selectedPlaylist?.items));

    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} fullScreen>
      <DialogTitle>Editing Chosen Layout</DialogTitle>
      <DialogContent>
        {selectedPlaylist ? (
          <Box>
          
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              gap={2}
              mt={2}
              sx={{
                overflowY:{
                  xs:"scroll",
                  md:"unset"
                }
              }}
            >
              {selectedPlaylist?.items.every(
                (item) => item.type === "content"
              ) ? (
                <Typography
                  variant="h6"
                  sx={{ textAlign: "center", marginTop: 2 }}
                >
                  All items are user-uploaded images. No inputs required.You may
                  proceed.
                </Typography>
              ) : (
                selectedPlaylist?.items.map((item, i) => {
                  if (item.type !== "template" && item.type !== "contentAI") {
                    return null;
                  }

                  const templateEntry = templates.find(
                    (t) => t.id === item.content_ref
                  );

                  return (
                    <Card
                      key={i}
                      sx={{
                        width: {xs:"100%",md:"30%"},
                        minWidth: 250,
                        height: "30%",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        padding: 2,
                      }}
                    >
                      <CardContent>
                        {item.type === "template" && templateEntry && (
                          <>
                            <h2
                              style={{
                                textAlign: "center",
                                marginBottom: "20px",
                              }}
                            >
                              {templateEntry?.name || "Template Name"}
                            </h2>

                            {templateEntry?.arguments &&
                            Object.keys(templateEntry.arguments || {}).length >
                              0 ? (
                              Object.entries(templateEntry.arguments)
                                .filter(([arg]) => arg.trim() !== "")
                                .map(([arg, value]) => {
                                  console.log(
                                    "arg:",
                                    arg,
                                    "value:",
                                    value,
                                    templateEntry.name
                                  );
                                  return (
                                    <ArgumentField
                                      key={`${item.id}_${arg}`}
                                      arg={arg}
                                      value={
                                        editableValues[`${item.id}_${arg}`] ||
                                        value ||
                                        ""
                                      }
                                      placeholder={
                                        ["event_name", "host_name"].includes(
                                          arg
                                        )
                                          ? "Autofilled"
                                          : ""
                                      }
                                      disabled={[
                                        "event_name",
                                        "host_name",
                                      ].includes(arg)}
                                      onInputChange={(key, value) =>
                                        handleInputChange(
                                          key,
                                          value,
                                          templateEntry.id,
                                          item.id
                                        )
                                      }
                                      onFileChange={(key, file) =>
                                        handleFileChange(
                                          key,
                                          file,
                                          templateEntry.id,
                                          item.id
                                        )
                                      }
                                    />
                                  );
                                })
                            ) : (
                              <Typography
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                No arguments available
                              </Typography>
                            )}
                          </>
                        )}

                        {item.type === "contentAI" && (
                          <BookModelRight layoutItem={layoutItem} />
                        )}
                      </CardContent>
                    </Card>
                  );
                })
              )}
            </Box>
          </Box>
        ) : (
          <Typography color="error">No playlist found</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="error">
          Close
        </Button>
        <Button onClick={handleConfirm} color="primary">
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  );
};
